import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/shared/component/app/base.component';
import { ComponentsPlatVideoComponent } from 'src/app/shared/component/common/play-video.component';

@Component({
  selector: 'app-hispital-patient-readimg..component',
  template: `
    <nz-spin [nzSpinning]="loading">
      <div class="modal-header">
        <div class="modal-title">查看文件</div>
      </div>
      <nz-image-group>
        <span *ngFor="let img of imgs">
          <img nz-image width="100px" *ngIf="img.type === '1'" height="100px" class="mr-md mb-md" [nzSrc]="img.path" />
          <img
            width="100px"
            *ngIf="img.type === '2'"
            (click)="playVideo(img)"
            height="100px"
            class="mr-md mb-md"
            src="/assets/img/视频.png"
          />
          <img
            width="100px"
            *ngIf="img.type === '3'"
            (click)="download(img)"
            height="100px"
            class="mr-md mb-md"
            src="/assets/img/文件.png"
          />
        </span>
      </nz-image-group>
      <div class="modal-footer">
        <button nz-button [nzType]="'primary'" (click)="ok()"> 确定 </button>
      </div>
    </nz-spin>
  `,
  styles: [
    `
      .circle {
        display: inline-block;
        width: 20px;
        height: 20px;
        // overflow: hidden;
        line-height: 20px;
        text-align: center;
        background-color: rgba(255, 255, 255, 0.6);
        // border: 1px solid #ccc;
        border-radius: 50%;
        cursor: pointer;
      }
      .circle.checked {
        color: #fff;
        background-color: #1890ff;
      }
    `
  ]
})
export class HospitalpatienreadimgComponent extends BaseComponent implements OnInit {
  cancel() {
    this.modalRef.close();
  }
  ok() {
    this.modalRef.close();
  }
  imgs: any = [];
  playVideo(mp4: any) {
    this.modal.createStatic(ComponentsPlatVideoComponent, { mp4: mp4.path }, { size: 400 }).subscribe(res => {});
  }
  download(mp4: any) {
    window.open(mp4.path);
  }
}
